import './friends.css'

const Friends = ({friends}) => {
  return (
      <div className="friends_col">
            {
                  friends.map((item, index) => (
                        <div className="friend_row" key={index}>
                              <img src={item.avatar} alt={item.name} />
                              <div className="friend_row_data">
                                    <strong>{item.name}</strong>
                                    <p>{item.description}</p>
                                    <a href={item.me} target="_blank" rel="noreferrer">xat.me</a>
                              </div>
                        </div>
                  ))
            }
      </div>
  )
}

export default Friends
